<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <BaseCard
              :loading-allowed="false"
              :v-card-text-class="'pa-0'"
              icon="mdi-filter-variant"
              title="Direct Receive Filter"
          >
            <v-form @submit.prevent="submit">
              <v-row class="pa-2">
                  <v-col cols="12" lg="3" md="2" sm="6">
                    <v-date-input
                      v-model="from_date.value.value"
                      :error-messages="from_date.errorMessage.value"
                      autocomplete="off"
                      bg-color="grey-lighten-4" clearable density="compact"
                      input-format="dd/mm/yyyy"
                      label="From Date"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-month" single-line variant="outlined"
                    />
                  </v-col>
                  <v-col cols="12" lg="3" md="2" sm="6">
                    <v-date-input
                      v-model="to_date.value.value"
                      :error-messages="to_date.errorMessage.value"
                      autocomplete="off"
                      bg-color="grey-lighten-4" clearable density="compact"
                      hide-details="auto" input-format="dd/mm/yyyy"
                      label="To Date"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-month" single-line variant="outlined"/>
                  </v-col>
                  <v-col cols="12" lg="3" md="3" sm="6">
                    <v-autocomplete
                        v-model="warehouse_id.value.value"
                        :error-messages="warehouse_id.errorMessage.value"
                        :item-title="(item) => `${item.name}`"
                        :items="getWarehouseList" :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        autocomplete="off" bg-color="grey-lighten-4"
                        clearable density="compact"
                        hide-details="auto" item-value="id" label="Warehouse"
                        variant="outlined"/>
                  </v-col>
                  <v-col cols="12" lg="3" md="3" sm="6">
                    <v-autocomplete
                      v-model="supplier_id.value.value"
                      :error-messages="supplier_id.errorMessage.value"
                      :item-title="(item) => `${item.name}`"
                      :items="getSupplierList" :menu-props="{ contentClass: 'my-custom-dropdown' }"
                      autocomplete="off" bg-color="grey-lighten-4"
                      clearable density="compact"
                      hide-details="auto" item-value="id" label="Supplier"
                      variant="outlined"/>
                  </v-col>
                </v-row>
              <v-divider></v-divider>
              <v-card-actions class="justify-end">
                <v-btn
                    ref="searchButton"
                    class="bg-brand"
                    prepend-icon="mdi-magnify"
                    type="submit"
                >
                  Search
                </v-btn>
              </v-card-actions>
            </v-form>
          </BaseCard>
        </v-col>

        <v-col cols="12">
          <BaseCard
              :loading-allowed="false"
              :v-card-text-class="'pa-0'"
              icon="mdi-clipboard-text-outline"
              title="Direct Receive List"
          >
            <v-row align="center" class="py-2 px-1">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search"
                  append-inner-icon="mdi-magnify"
                  bg-color="grey-lighten-4"
                  clearable density="compact"
                  hide-details
                  label="Search"
                  single-line
                  variant="outlined"/>
              </v-col>
              <v-col cols="12" md="4">
                <div class="d-flex align-center flex-column">
                  <v-btn-group density="compact" divided size="small" variant="outlined">
                    <v-btn
                      color="success"
                      prepend-icon="mdi-download"
                      variant="flat"
                      @click="exportToCSV"
                    >
                      CSV
                    </v-btn>
                    <v-btn
                    color="primary"
                    prepend-icon="mdi-download"
                    variant="flat"
                   @click="exportToExcel"
                    >
                      EXCEL
                    </v-btn>
                    <v-btn
                      color="red"
                      prepend-icon="mdi-download"
                      variant="flat"
                      @click="exportToPDF"
                    >
                      PDF
                    </v-btn>
                  </v-btn-group>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-right pr-2">
                  <v-btn
                    v-if="$insertAccess($route.fullPath)"
                   color="primary"
                    prepend-icon="mdi-plus"
                    rounded="xl"
                    variant="tonal"
                    @click="goTo('/inventory/direct-receive')"
                  >
                    Create Direct Receive
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <v-data-table
              v-model:items-per-page="itemsPerPage"
              :headers="headers"
              :hover="true"
              :items="getSchema"
              :loading="loading"
              :search="search"
              density="compact"
            >
              <template v-slot:loader>
                <v-progress-linear
                    :color="loading"
                    height="3"
                    indeterminate
                />
              </template>
              <template v-slot:item.index="{ index }">{{ ++index }}</template>
              <template v-slot:item.approval_status_display="{ item }">
                <v-chip
                  v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                  color="yellow-darken-3"
                  size="small"
                >
                  Waiting for {{ item.approval_current_process.approval_step_name.name }}
                </v-chip>
                <v-chip
                  v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                  color="green"
                  size="small"
                >
                  Approved By {{ item.approval_current_process.approval_step_name.name }}
                </v-chip>
                <v-chip
                  v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                  color="red"
                  size="small"
                >
                  Cancelled By {{ item.approval_current_process.approval_step_name.name }}
                </v-chip>
                <v-chip v-else color="green" size="small">{{ item.approval_status }}</v-chip>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip
                    v-if="item.status == 1"
                    class="text-capitalize"
                    color="success"
                    size="small"
                >
                  Active
                </v-chip>
                <v-chip
                  v-else
                  class="text-capitalize"
                  color="red"
                  size="small"
                >
                  Inactive
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  v-if="$updateAccess($route.fullPath) && canEdit(item)"
                  class="me-2 edit-button"
                  color="primary"
                  title="Edit"
                  @click="editItem(item)"
                >
                  mdi-pencil-outline
                </v-icon>
                <v-icon color="blue" title="View Receive Details"
                        @click="viewReceiveDetails(item)">mdi-file-document-outline
                </v-icon>
              </template>
            </v-data-table>
          </BaseCard>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import {useStore} from "vuex";
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import {ref} from "vue";
import {toast} from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import BaseCard from "@/components/utils/baseCard.vue";

export default {
  components: {
    BaseCard
  },
  data: () => ({
    itemsPerPage: 10,
    loading: false,
    search: "",
    dialog: false,
    data: {},
    headers: [
      {title: "#SL", align: "center", key: "index", width: "7%", sortable: false},
      {title: "Code", key: "code", align: "center", sortable: false},
      {title: "Supplier", key: "supplier.name", align: "left", sortable: false},
      {title: "Warehouse", align: "left", key: "warehouse.name", sortable: true},
      {title: "Purpose/Project", align: "left", key: "purpose.name", sortable: true},
      {title: "Amount", align: "end", key: "amount", sortable: true},
      {title: "Approval Status", align: "center", key: "approval_status_display", sortable: true},
      {title: "Status", align: "center", key: "status", sortable: true},
      {title: "Actions", align: "center", key: "actions", sortable: false},
    ],
  }),
  watch: {},
  created() {
    // if (this.$store.getters.getSupplierList.length === 0) {
    this.$store.dispatch("getSupplierList");
    // }
    // if (this.$store.getters.getWarehouseList.length === 0) {
    this.$store.dispatch("getWarehouseList");
    // }
  },
  computed: {
    getSchema() {
      return this.$store.getters.getInvDirectReceiveList || [];
    },
    getSupplierList() {
      return this.$store.getters.getSupplierList;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
  },
  setup() {
    const {handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
        // from_date: yup.date().required().label('Requisition Date'),
        // supplier_id: yup.number().positive().integer().nullable().label('supplier Name'),
        // warehouse_id: yup.number().positive().integer().nullable().label('Warehouse Name'),
      }),
    });

    const supplier_id = useField("supplier_id");
    const warehouse_id = useField("warehouse_id");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = "blue-darken-3";
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
          .dispatch("getInvDirectReceiveList", values)
          .then((response) => {
            loading.value = false;
          })
          .catch((error) => {
            toast.error(error.response.data.message);
          });
    });
    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      supplier_id,
      warehouse_id,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({path: val}).catch((err) => {
      });
    },
    editItem(item) {
      // this.$store.commit('setEditingRequisition', item);
      this.$router.push({
        name: "direct-receive",
        query: {id: item.id},
      });
      // this.data = { ...item };
      // this.dialog = true;
    },
    canEdit(item) {
      return (!item.approval_status || item.approval_status.toLowerCase() == 'pending' || item.status == 0)
    },
    viewReceiveDetails(item) {
      console.log("Viewing receive details for item:", item);
      this.$router.push({
        name: "view-direct-receive",
        params: {id: item.id},
      }).catch((err) => {
        console.error("Navigation error:", err);
      });
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Code",
        "supplier",
        "Warehouse",
        "Amount",
        "Approval Status",
        "Status",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.code,
        item.supplier.name,
        item.warehouse.name,
        item.amount,
        item.approved_ind === 1 ? "YES" : "NO",
        item.status == 1 ? "POST" : "DRAFT",
      ]);
      this.$exportTableToPDF(
          columns,
          rows,
          "Direct Receive List",
          "direct_receive_list" + this.$fileDate(),
          "landscape"
      );
    },
    exportToExcel() {
      var data = [
        [
          "#SL",
          "Code",
          "supplier",
          "Warehouse",
          "Amount",
          "Approval Status",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.supplier.name,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES" : "NO",
          item.status == 1 ? "POST" : "DRAFT",
        ]);
      });
      this.$exportTableToExcel(data, "direct_receive_list" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [
          "#SL",
          "Code",
          "supplier",
          "Warehouse",
          "Amount",
          "Approval Status",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.supplier.name,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES" : "NO",
          item.status == 1 ? "POST" : "DRAFT",
        ]);
      });

      this.$exportTableToCSV(data, "direct_receive_list" + this.$fileDate());
    },
  },
  mounted() {
    this.from_date.value.value = new Date();
    this.to_date.value.value = new Date();
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });
  },
};
</script>
